export default "__VITE_ASSET__D7zN2J9D__"